function getFullName(firstName: string, lastname: string): string {
  return `${firstName} ${lastname}`;
}

export { getFullName };
